<template>
    <div>
        <v-form name="manageConfidentialForm" ref="manageConfidentialForm">
            <div class="tw-flex tw-flex-row tw-gap-6 tw-p-1">
                <div class="tw-flex tw-flex-col tw-gap-2">
                    <date-picker
                        v-model="member.dob"
                        dense
                        color="primary"
                        display-label="DOB"
                        :error-messages="errors?.dob"
                        hide-details="auto"
                        reactive
                        clearable
                        ref="datePicker"
                    />
                    <v-text-field
                        v-model="member.nas"
                        :type="showSin ? 'text' : 'password'"
                        label="SIN"
                        id="sin"
                        name="sin"
                        :error-messages="errors?.nas"
                        hide-details="auto"
                        dense
                        :append-icon="showSin? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append="showSin = !showSin"
                    ></v-text-field>

                    <div>
                        <v-autocomplete
                            v-model="gender_ids"
                            :items="valuelists.GENDERS"
                            label="Gender"
                            :error-messages="errors?.gender"
                            hide-details="auto"
                            :menu-props="{top: true}"
                            multiple
                            dense
                            reactive
                            outlined
                            clearable
                        ></v-autocomplete>
                        <v-text-field
                            v-if="isOtherSelected(gender_ids, valuelists.GENDERS)"
                            v-model="gender_other"
                            label="Other Gender"
                            class="pt-2"
                            hide-details="auto"
                            outlined
                            dense
                            clearable
                        />
                    </div>

                    <div>
                        <v-select
                            v-model="pronoun_ids"
                            :items="valuelist.PRONOUNS"
                            label="Pronouns"
                            hide-details="auto"
                            :menu-props="{top: true}"
                            multiple
                            dense
                            reactive
                            outlined
                            clearable
                        ></v-select>
                        <v-text-field
                            v-if="isOtherSelected(pronoun_ids, valuelists.PRONOUNS)"
                            v-model="pronoun_other"
                            label="Other Pronoun"
                            class="pt-2"
                            hide-details="auto"
                            outlined
                            dense
                            clearable
                        />
                    </div>

                    <div>
                        <v-autocomplete
                            v-model="racial_category_ids"
                            :items="valuelists.RACIAL_CATEGORIES"
                            label="Racial Categories"
                            hide-details="auto"
                            :menu-props="{top: true}"
                            multiple
                            dense
                            reactive
                            outlined
                            clearable
                        ></v-autocomplete>
                        <v-text-field
                            v-if="isOtherSelected(racial_category_ids, valuelists.RACIAL_CATEGORIES)"
                            v-model="racial_category_other"
                            label="Other Racial Category"
                            class="pt-2"
                            hide-details="auto"
                            outlined
                            dense
                            clearable
                        />
                    </div>

                    <div>
                        <v-autocomplete
                            v-model="marital_status_ids"
                            :items="valuelists.MARITAL_STATUSES"
                            label="Marital Status"
                            hide-details="auto"
                            :menu-props="{top: true}"
                            multiple
                            dense
                            reactive
                            outlined
                            clearable
                        ></v-autocomplete>
                        <v-text-field
                            v-if="isOtherSelected(marital_status_ids, valuelists.MARITAL_STATUSES)"
                            v-model="marital_status_other"
                            label="Other Marital Status"
                            class="pt-2"
                            hide-details="auto"
                            outlined
                            dense
                            clearable
                        />
                    </div>

                    <v-autocomplete
                        v-model="member.identification_usage_consent_id"
                        :items="valuelists.IDENTIFICATION_USAGES"
                        label="Approvals"
                        hide-details="auto"
                        dense
                        reactive
                        outlined
                        clearable
                    ></v-autocomplete>

                    <div>
                        <v-select
                            v-model="member.lgbt_identifying"
                            :items="getLgbtOptions"
                            label="Do you identify as LGBTQIA2S+"
                            :menu-props="{top: true, offsetY: true}"
                            outlined
                            dense
                            open-on-clear
                            clearable
                            hide-details="auto"
                        />
                        <v-text-field
                            v-if="member.lgbt_identifying === 'Other'"
                            v-model="member.lgbt_identifying_as"
                            label="Other"
                            hide-details="auto"
                            class="pt-2"
                            outlined
                            dense
                            clearable
                        />
                        <v-text-field
                            v-if="member.lgbt_identifying === 'Yes'"
                            v-model="member.lgbt_identifying_as"
                            label="How do you wish to be identified?"
                            hide-details="auto"
                            class="pt-2"
                            outlined
                            dense
                            clearable
                        />
                    </div>
                </div>
            </div>
            <div class="tw-p-1" v-show="isUserAdminOrStaff">
                <v-btn v-show="showResetPassword" @click="resetPassword" class="main-btn">Reset Password</v-btn>
            </div>
        </v-form>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import DatePicker from "@/Generic/DatePicker";

    export default {
        name: "MembersManageConfidential",
        components: {
            SmartTable,
            InternalHeader,
            DatePicker,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                member: this.input || {},
                identification_usage_consent_ids: null,
                gender_ids: [],
                gender_other: this.getOtherValue(this.valuelists?.GENDERS, this.input?.genders),
                racial_category_ids: [],
                racial_category_other: this.getOtherValue(this.valuelists?.RACIAL_CATEGORIES, this.input?.racial_categories),
                marital_status_ids: [],
                marital_status_other: this.getOtherValue(this.valuelists?.MARITAL_STATUSES, this.input?.marital_statuses),
                pronoun_ids: [],
                pronoun_other: this.getOtherValue(this.valuelists?.PRONOUNS, this.input?.pronouns),
                constant: this.constants,
                valuelist: this.valuelists,
                saveLoading: false,
                showSin: false,
                isEdit: this.isEditProp,
                errors: null,
            }
        },
        computed: {
            isUserAdminOrStaff() {
                return this.$page.user.role === 'ADMIN' || this.$page.user.role === 'STAFF';
            },
            showResetPassword() {
                return (this.isEdit && this.member.web_access && this.member.email);
            },
            getLgbtOptions() {
                return Object.values(this.constants.USER_LGBT)
            }
        },
        methods: {
            saveConfidential() {
                if (this.$refs.manageConfidentialForm.validate()) {
                    let payload = this.member
                    payload.gender_ids = this.gender_ids
                    payload.gender_other = this.gender_other
                    payload.pronoun_ids = this.pronoun_ids
                    payload.pronoun_other = this.pronoun_other
                    payload.marital_status_ids = this.marital_status_ids
                    payload.marital_status_other = this.marital_status_other
                    payload.racial_category_ids = this.racial_category_ids
                    payload.racial_category_other = this.racial_category_other

                    var url = ''
                    var method = ''

                    if(this.isEdit) {
                        url = route('members.update', this.member.id)
                        method = 'put'
                    } else {
                        url = route('members.store')
                        method = 'post'
                    }

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Changes have been saved')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.saveLoading = false
                                this.$emit('successful-manage-member-save')

                                if (!this.isEdit) {
                                    this.$inertia.visit(route('members.edit', response.data.data.id))
                                }
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknown error.')
                            }
                        })
                        .catch((error) => {
                            if( error?.response ) {
                                this.$root.snackbar.error(error.response.data.message)
                                this.errors = error.response?.data?.errors
                            } else {
                                console.log(error)
                                this.$root.snackbar.error(error)
                            }
                            this.saveLoading = false
                        })
                } else {
                    this.$root.snackbar.error('Please fill all required fields.')
                }
            },
            resetPassword () {
                axios.get(route('members.reset-password', this.member.id))
                    .then((response) => {
                        if (response.data.success) {
                            this.$root.snackbar.success('Password reset email has been sent')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            },
            getIdsFromArray(input_array) {
                if (!Array.isArray(input_array)) {
                    return null
                }
                return input_array.map(i=>i.id || i)
            },
            populateLocalPronouns() {
                if (this.isEditProp) {
                    this.pronoun_ids = this.getIdsFromArray(this.member?.pronouns)
                }
            },
            populateLocalGenders() {
                if (this.isEditProp) {
                    this.gender_ids = this.getIdsFromArray(this.member?.genders)
                }
            },
            populateLocalRacialCategories() {
                if (this.isEditProp) {
                    this.racial_category_ids = this.getIdsFromArray(this.member?.racial_categories)
                }
            },
            populateLocalMaritalStatuses() {
                if (this.isEditProp) {
                    this.marital_status_ids = this.getIdsFromArray(this.member?.marital_statuses)
                }
            },
            isOtherSelected(listSelected, list) {
                return listSelected.some(value => list.some(item => item.value === value && item.text === "Other"));
            },
            getOtherValue(valueList, list) {
                if (this.isEditProp) {
                    let otherId = valueList.find(item => item.text === "Other").value
                    let otherRecord = list.find(item => item.id === otherId)
                    return otherRecord?.pivot?.other
                } else {
                    return null
                }
            }
        },
        mounted() {
            this.populateLocalGenders()
            this.populateLocalPronouns()
            this.populateLocalRacialCategories()
            this.populateLocalMaritalStatuses()
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
            saveLoading(newValue, oldValue) {
                this.$emit('save-loading-change', newValue)
            },
            'member.pronouns': {
                // This converts the array of objects into just an array of ids
                immediate: true,
                handler: function (new_value) {
                    this.populateLocalPronouns()
                }
            },
            'member.genders': {
                // This converts the array of objects into just an array of ids
                immediate: true,
                handler: function (new_value) {
                    this.populateLocalGenders()
                }
            },
            'member.racial_categories': {
                // This converts the array of objects into just an array of ids
                immediate: true,
                handler: function (new_value) {
                    this.populateLocalRacialCategories()
                }
            },
            'member.marital_statuses': {
                // This converts the array of objects into just an array of ids
                immediate: true,
                handler: function (new_value) {
                    this.populateLocalMaritalStatuses()
                }
            },
        }
    }
</script>
